/** Series color palettes keyed by the `appearance.colorScheme` schema option. */
export const PALETTES: Record<string, string[]> = {
  default: ['#4f7cff', '#22b573', '#f5a623', '#e5533d', '#9b59d0', '#17a2b8'],
  warm: ['#e5533d', '#f5a623', '#d97706', '#ef6c4d', '#b45309', '#c2410c'],
  cool: ['#4f7cff', '#17a2b8', '#3b82f6', '#0ea5e9', '#6366f1', '#14b8a6'],
  mono: ['#111827', '#374151', '#4b5563', '#6b7280', '#9ca3af', '#d1d5db']
};

export function paletteFor(scheme: string): string[] {
  return PALETTES[scheme] ?? PALETTES['default']!;
}
